import React from 'react';
import authRoles from '../../../auth/authRoles';
import AdminDetail from '@/app/fuse-layouts/shared-components/adminDetail';
import Editprofile from '@/app/fuse-layouts/shared-components/Editprofile';

const SubAdminProfileConfig = {
	settings: {
		layout: {
			Config: {},
		},
	},
	routes: [
		{
			path: '/profile-view',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AdminDetail />
				</React.Suspense>
			),
		},
		{
			path: '/profile-edit',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Editprofile />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.subadmin,
};

export default SubAdminProfileConfig;
